import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "name", "value", "checked"]
const _hoisted_3 = { class: "ml-2 text-textPrimary text-base" }

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    id: {},
    name: {},
    value: { type: [String, Number, Boolean] },
    modelValue: { type: [String, Number, Boolean] },
    label: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const isChecked = computed(() => props.modelValue === props.value)

const handleChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    for: _ctx.id,
    class: "flex items-center cursor-pointer select-none"
  }, [
    _createElementVNode("input", {
      id: _ctx.id,
      type: "radio",
      name: _ctx.name,
      value: _ctx.value,
      checked: isChecked.value,
      onChange: handleChange,
      class: "hidden"
    }, null, 40, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(["w-[18px] h-[18px] rounded-full border-2 transition-all duration-200 ease-in-out flex items-center justify-center", {
        'border-primary': isChecked.value,
        'border-gray-400': !isChecked.value
      }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-2.5 h-2.5 rounded-full bg-primary transition-all duration-200 ease-in-out", {
          'opacity-100 scale-100': isChecked.value,
          'opacity-0 scale-0': !isChecked.value
        }])
      }, null, 2)
    ], 2),
    _createElementVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})